import React from "react";

import PrivacyPageV1 from "../../component/pages/PrivacyPage";
import PrivacyPageV2 from "../../V2/components/pages/PrivacyPage";

function Privacy() {
  const isV2 = process.env.NEXT_PUBLIC_REACT_APP_SKIN === "taxnumber" 
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4";

  if (isV2) {
    return (
      <PrivacyPageV2 />
    )
  }

  return (
    <PrivacyPageV1 />
  );
}

export default Privacy;
